@file:OptIn(ExperimentalUuidApi::class)

package fr.arcplex.network.model

import fr.arcplex.network.http.JsonMap
import kotlin.uuid.ExperimentalUuidApi
import kotlin.uuid.Uuid

/**
 * Unified rail item: one content entry of a rail (text or image) plus its
 * optional button action. Replaces the legacy `LineItem`.
 */
data class RailItem(
    val uid: String,
    val type: String,
    val content: String = "",
    val label: String? = null,
    val altText: String? = null,
    val programId: String? = null,
    val action: ItemAction? = null,
    val height: Float = 60f,
    val width: Float = 60f,
    val keyboardSecret: Boolean = false,
    val keyboardHideData: Boolean = false
)

data class ItemAction(
    val type: String? = null,
    val url: String? = null
)

/**
 * Maps the `content.objects` array of a line (or of a refreshLine response) to
 * [RailItem]s.
 */
fun parseRailItems(objects: JsonMap?): List<RailItem> =
    objects?.getList()?.mapNotNull { item ->
        item?.let {
            RailItem(
                uid = it.getString("uid")?.takeIf { u -> u.isNotEmpty() } ?: Uuid.generateV7().toHexString(),
                type = it.getString("type") ?: "txt",
                content = it.getString("content") ?: "",
                label = it.getString("label"),
                altText = it.getString("html_alt_txt")?.drop(5)?.dropLast(20),
                programId = it.getString("id_programme"),
                action = ItemAction(
                    type = it.get("actions")?.get("btn_OK")?.getString("type"),
                    url = it.get("actions")?.get("btn_OK")?.getString("url")
                ),
                height = (it.getNumber("e_height")?.toFloat() ?: 60f) / 2,
                width = (it.getNumber("e_width")?.toFloat() ?: 60f) / 2,
                keyboardSecret = it.getBoolean("keyboard_secret") == true,
                keyboardHideData = it.getBoolean("keyboard_hide_datas") == true
            )
        }
    } ?: emptyList()
